import {
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  FormHelperText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import OutlinedContainer from "./Container/OutlinedContainer";

export default function RadioGroup(props) {
  const { name, value, onChange, items, width, required, error, helperText } =
    props;
  const { t } = useTranslation();
  return (
    <OutlinedContainer
      label={t(`FORM.FIELD.${name}`)}
      required={required}
      width={width || "100%"}
    >
      <MuiRadioGroup
        variant="outlined"
        row
        name={name}
        value={value}
        onChange={onChange}
      >
        {items.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item.value}
            label={t(`FORM.OPTIONS.${item.label}`)}
            control={<Radio />}
          ></FormControlLabel>
        ))}
      </MuiRadioGroup>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </OutlinedContainer>
  );
}
